






















































































































































import { User } from "@/store/modules/types";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CallsLogin extends Vue {
  username = "";
  password = "";
  async login() {
    const { username, password } = this;
    if (!username || !password) {
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      const user: User = await this.$store.dispatch("auth/login", {
        username,
        password,
      });
      const { ENABLE_CALLS_MODULE } = user.settings;
      if (ENABLE_CALLS_MODULE) {
        this.$router.push({ name: "calls" });
      } else {
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: "You don't have access to this module.",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
      this.password = "";
    }
  }
}
